

















import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    title: {
      type: String as () => string,
    },
  },

  computed: {
    attrs(): any {
      return {
        'max-width': 500,
        value: this.visible,
        ...this.$attrs,
      };
    },

    listeners(): any {
      return {
        ...this.$listeners,
      };
    },
  },

  data(): {
    visible: boolean;
    internal: {
      resolve?: any;
      reject?: any;
    };
  } {
    return {
      visible: false,
      internal: {
        resolve: undefined,
        reject: undefined,
      },
    };
  },

  methods: {
    open(params?: any) {
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.internal = {
          resolve: resolve,
          reject: reject,
        };
      });
    },

    resolve(result?: any) {
      this.internal.resolve(result);
      this.visible = false;
      this.internal = {};
    },

    reject(result?: any) {
      this.internal.reject(result);
      this.internal = {};
      this.visible = false;
    },

    handleClose() {
      this.$emit('close');
    },
  },
});
